export const appConfig = {
    backendUrl: 'https://qa3.srw.aisnovations.com',
    logging: {
        enableSending: false,
    },
};
